var map = {
	"./cs.json": [
		80723,
		80723
	],
	"./de.json": [
		24214,
		24214
	],
	"./en.json": [
		18030,
		18030
	],
	"./es.json": [
		43877,
		43877
	],
	"./fr.json": [
		95181,
		95181
	],
	"./it.json": [
		66424,
		66424
	],
	"./ja.json": [
		54924,
		54924
	],
	"./ko.json": [
		2175,
		2175
	],
	"./pl.json": [
		81877,
		81877
	],
	"./pt-br.json": [
		53720,
		53720
	],
	"./pt.json": [
		92237,
		92237
	],
	"./ru.json": [
		84072,
		84072
	],
	"./tr.json": [
		58059,
		58059
	],
	"./zh.json": [
		69607,
		69607
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 80736;
module.exports = webpackAsyncContext;